import React, {useState, useEffect} from "react";
import axios from 'axios';
import { UTILS } from "../../constants";

import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

export const CoverPopup = ({setgetId,cardDetail,setShowCover,colors,handleFileCoverChange,coverAttactment,setCoverAttachment}) => {
  //  console.log("coverAttactment1",cardDetail);
  //  console.log("cardDetail.attachments",cardDetail.attachments);
  const [cardDetailcover, setcardDetailcover] = useState(cardDetail);
   
   let [selectImg, setSelectImg]=useState();
  let [coverImg, setCoverImg]=useState([]);

  useEffect(() =>{
     setCoverImg(cardDetailcover && cardDetailcover.attachments);
  },[cardDetailcover]);
  const imageExtensions = ["image/jpg", "image/jpeg", "image/png", "image/gif"];

  const filteredImages = coverImg && coverImg.filter((file) =>
    imageExtensions.includes(file.mime_type)
  );
  // const updateCardInBoardList = (boardListId, cardId, updatedCard) => {
  //   setBoardlist(prevBoardlist => {
  //     return {
  //       ...prevBoardlist,
  //       board_lists: prevBoardlist.board_lists.map(board => {
  //         if (board.id === boardListId) {
  //           return {
  //             ...board,
  //             cards: board.cards.map(card => 
  //               card.id === cardId ? { ...card, ...updatedCard } : card
  //             )
  //           };
  //         }
  //         return board;
  //       })
  //     };
  //   });
  // };
  const handleSetCoverImage =async (file, id) => {
   
    const formData = new FormData();
    formData.append('task_id', cardDetail?.id);
    formData.append('attachment_id', id);
  
    try {
      const response = await axios.post(
        `${UTILS.API_url}board/v1/board-list-cards/cover-image/attachment-as-cover-image`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("trelloToken")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      
      // console.log("Response:setShowCover", response.data);
      handleFileCoverChange(response.data.board_list_card);
      setcardDetailcover(response.data);
      toast.success(response.data.success);
      setShowCover((prevState) => ({
        ...prevState,
        cover_image: file, // Update only the cover_image
      }));
      setgetId(null);
    } catch (error) {
      console.error("Error updating cover image:", error);
    }


  };
  const handleSetCoverColor=(color) =>{
    setShowCover((prevState) => ({
      ...prevState,
      cover_background_color: color, // Update only the cover_image
    }));
  }

  const handleDeleteCover=async() =>{


    setShowCover(null);
    // const formData = new FormData();
    // formData.append('task_id', cardDetail?.id);
    // formData.append('attachment_id', id);
  
    try {
      // const response = await axios.post(
      //   `${UTILS.API_url}board/v1/board-list-cards/cover-image/delete-as-cover-image`,
      //   formData,
      //   {
      //     headers: {
      //       Authorization: `Bearer ${localStorage.getItem("trelloToken")}`,
      //       "Content-Type": "multipart/form-data",
      //     },
      //   }
      // );
      
      // console.log("Response:setShowCover", response.data);
  
    } catch (error) {
      console.error("Error updating cover image:", error);
    } 
  }

  
  useEffect(() =>{
   if(coverAttactment !== null){
    // console.log("coverAttactment",coverAttactment);
    
    // console.log("coverAttactment",coverAttactment);
    handleSetCoverImage(coverAttactment[0].file_path,coverAttactment[0].id);
    setCoverAttachment(null)

   }
  });

  
  const updateCoverImage = (event) =>{
    // handleFileCoverChange(event);
    //  console.log("event.target.files",event.target.files);
    //  let imageFile=[event.target.files]
     const imageFile = event.target.files[0];

    // console.log("imageFile",imageFile);

    // if (files.length > 0) {
      const formData = new FormData();
     
      formData.append("task_id", cardDetail?.id); 
      formData.append("cover_image", imageFile); 

      const randomString = Math.random().toString(36).substring(2, 5);
    
      axios
        .post(
          `${UTILS.API_url}board/v1/board-list-cards/cover-image/update?${randomString}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("trelloToken")}`, // Adjust token name as per your application
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          toast.success(response.data.success);
          handleFileCoverChange(response.data.board_list_card)
          // console.log("Image uploaded successfully", response.data);
          // setCoverAttachment(response.data.board_list_card)

          // console.log(coverImg)
          setCoverImg((prevState) => ({
            ...prevState,
            cover_image: [...prevState.cover_image, response.data.attachment], // Append the new attachment
          }));
        })
        .catch((error) => {
          console.error("Error uploading image", error);
        });
    // }
    


  };


  const isRecent = (createdAt, limitInMinutes) => {
    // Check if createdAt is defined and is a string
    if (typeof createdAt !== 'string') return false;

    const currentTime = new Date();
    let timeDiffInMillis;

    if (createdAt.includes('second')) {
        const seconds = parseInt(createdAt.split(' ')[0], 10);
        timeDiffInMillis = seconds * 1000; // Convert seconds to milliseconds
    } else if (createdAt.includes('minute')) {
        const minutes = parseInt(createdAt.split(' ')[0], 10);
        timeDiffInMillis = minutes * 60 * 1000; // Convert minutes to milliseconds
    } else {
      const minutes = 50;
        timeDiffInMillis = minutes * 60 * 1000; // Convert minutes to milliseconds
        // return false; // Return false if the format isn't recognized
    }

    const createdTime = new Date(currentTime.getTime() - timeDiffInMillis);
    const differenceInMillis = currentTime - createdTime;

    return differenceInMillis > limitInMinutes * 60 * 1000; // Convert limit to milliseconds
};

  return (
    <div className="add-member">
      <button className="close-btn-pop close-member">
        <span className="material-symbols-outlined" onClick={() => setgetId(null)}>close</span>
      </button>
      <div className="dropdown-fields">
        <h4 className="mem-heading">Cover</h4>

        <h3 className="bm-heading">Colors</h3>
     
        <ul className="color-list">
        {colors && colors.map((value) => {
           return(
            <li style={{padding: "2px 0px"}}>
            <span
              className="list-diamension cover-image-bg-color"
              id={value.id} // Convert name to id-friendly format
              data-id={value.id}
              // title={"blue"} // Optional: Show color name on hover
              data-color-position={value.color_position}
              data-color-id={value.id}
              style={{
                backgroundColor: value?.color_value,
                // border:
                //   selectedColor === value.id
                //     ? "2px solid black"
                //     : "none",
              }}
              onClick={() => handleSetCoverColor(value?.color_value)}
            ></span>
          </li>
           )
        })}
      
        </ul>
        {filteredImages.length > 0 && (
  <h3 className="bm-heading">Attachments </h3>
)}
        <div
    className="attachments-for-cover"
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: "4px",
      width: "100%",
    }}
  >
    {filteredImages.map((file, index) => (
      <img
        key={file.id}
        // src={
        //   isRecent(file?.created_at , 10)
        //   ? UTILS.images_url + "150x150/" + file?.file_name
        //   : UTILS.temp_image_url + "150x150/" + file?.file_name
        // }
        src={
              isRecent(file?.created_at, 10)
                ? UTILS.images_url +
                  (file?.file_name?.toLowerCase().endsWith('.gif') ? 'original/' : '150x150/') +
                  file?.file_name
                : UTILS.temp_image_url +
                  (file?.file_name?.toLowerCase().endsWith('.gif') ? 'original/' : '150x150/') +
                  file?.file_name
            }
        // src={
        //   UTILS.images_url + "150x150/" + file?.file_name
        // }
        // src={file.file_path}
        alt={`attachment-${index + 1}`}
        style={{
          width: "65px",
          height: "50px",
          objectFit: "cover",
          objectPosition: "center",
          borderRadius: "4px",
          cursor: "pointer",

        }}
        onClick={() => handleSetCoverImage(file.file_path,file.id)}
      />
    ))}
  </div>


  <div className="upload-btn-wrapper">
          <label for="fileAttachment" className="fileattach-label">
            Upload Cover
          </label>
          <input
            type="file"
            id="fileAttachment"
            className="add-attachment"
            accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip, image/*"
            multiple
            onChange={updateCoverImage}
          />
        </div>

        <div className="delete-btn-wrapper">
          <label for="delete" className="fileattach-label" onClick={handleDeleteCover}>
            Delete Cover
          </label>
        </div>

        {/* <div
          className="upload-btn-wrapper border-none"
          style={{ margin: "8px 0px" }}
        >
          <input
            type="file"
            id="upload-cover-image"
            accept="image/*"
            className="upload-cover-image"
          />
          <label className="file-input__label" for="upload-cover-image">
            <span className="material-symbols-outlined">credit_card</span>{" "}
            <span>Upload a Cover Image</span>
          </label>
        </div>
        <p>Tip: Drag an image on to the card to upload it. </p> */}
      </div>
    </div>
  );
};
